// extracted by mini-css-extract-plugin
export default {"wrapper":"Setting_wrapper__Ohqfa","tabSection":"Setting_tabSection__c5jbz","tab":"Setting_tab__QRsnV","active":"Setting_active__brWLG","content":"Setting_content__IC8y9"};